import PropTypes from "prop-types"
import { forwardRef } from "react"

import { cn } from "styles/utils"

const Divider = forwardRef(({ className, ...props }, ref) => (
  <hr
    className={cn(
      "bg-grey-10 outline-hidden mb-8 mt-8 h-px border-0",
      className
    )}
    ref={ref}
    {...props}
  />
))

Divider.displayName = "Divider"

Divider.propTypes = {
  className: PropTypes.string,
}

export default Divider
